import { z } from 'zod'

export const programSearchSchema = z.object({
  search: z.string().max(200).optional().catch(undefined),
  status: z.enum(['all', 'active', 'inactive']).catch('all'),
  page: z.coerce.number().int().min(1).catch(1),
  pageSize: z.coerce
    .number()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(10),
  sortBy: z
    .enum(['name', 'type', 'profName', 'hours', 'itemCount', 'internshipCount', 'active'])
    .catch('name'),
  direction: z.enum(['asc', 'desc']).catch('asc'),
})

export type ProgramSearch = z.infer<typeof programSearchSchema>

export const defaultProgramSearch: ProgramSearch = {
  status: 'all',
  page: 1,
  pageSize: 10,
  sortBy: 'name',
  direction: 'asc',
}
